import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

export default function FormTree({
	collapsed,
	items,
	setActiveInput,
	setActive,
}) {
	const [openContainers, setOpenContainers] = useState({});

	const toggleContainer = (key) => {
		setOpenContainers((prev) => ({
			...prev,
			[key]: !prev[key],
		}));
	};
	const setActiveField = (id) => {
		setActive(true);
		setActiveInput(id);
	};
	return (
		<div>
			{items.map((i) => (
				<React.Fragment key={i.key}>
					{i.name === "Container" ? (
						<>
							<div
								className="d-flex align-items-center pointer"
								onClick={() => setActiveField(i.key)}
							>
								<IoIosArrowDown
									style={{
										transform: `translateY(-40%) rotate(${
											!openContainers[i.key] ? "0deg" : "-90deg"
										})`,
										transition: "transform 0.2s",
										marginRight: "4px",
									}}
									onClick={() => toggleContainer(i.key)}
								/>
								<p className="me-2">{i.key}</p>
								<p>{i?.name}</p>
							</div>

							{!openContainers[i.key] &&
								i.container.map((j) => (
									<div
										key={j.key}
										className="ms-4 d-flex align-items-center pointer"
										onClick={() => setActiveField(j.key)}
									>
										<p className="me-2">{j?.key}</p>
										<p>{j?.name}</p>
									</div>
								))}
						</>
					) : (
						<div
							key={i.key}
							className="d-flex align-items-center pointer"
							onClick={() => setActiveField(i.key)}
						>
							<p className="me-2">{i?.key}</p>
							<p>{i?.name}</p>
						</div>
					)}
				</React.Fragment>
			))}
		</div>
	);
}
